export const FEE_LOADING = 'FEE_LOADING';
export const FEE_FULFILLED = 'FEE_FULFILLED';
export const FEES_FULFILLED = 'FEES_FULFILLED';
